import { IUserInit } from '../interfaces/IUserInit';
import { DashboardUserRoute } from '../types/DashboardUserRouteTypes';

export class CustomerInit implements IUserInit {
  private dashboardUserRoute: DashboardUserRoute = 'dashboard';

  public getDashboardUserRoute() {
    return this.dashboardUserRoute;
  }
}
